/**
 * 产品服务
 */
<template>
  <div class="product">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>我的服务</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <!-- 产品列表 s -->
      <div class="product-table" >

        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
          <el-form-item label="到期时间">
            <el-row :gutter="20">

              <el-col :span="9.5">
                <div class="grid-content bg-purple">
                  <el-date-picker size="small" v-model="daterange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="left">
                  </el-date-picker>
                </div>
              </el-col>
              <!-- <el-col :span="4">
                <div class="grid-content bg-purple">
                  <el-select size="small" clearable=true v-model="formInline.dateCount" placeholder="到期时限">
                    <el-option v-for="item in orderStatus" :key="item.value" :label="item.key" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col> -->
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-input size="small" :clearable="true" v-model="formInline.productName" placeholder="输入服务名称查询"></el-input>
                </div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content bg-purple">
                  <el-form-item>
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

          </el-form-item>

        </el-form>

        <!--列表-->
        <el-table size="small" :data="listData" row-key="item" highlight-current-row v-loading="loading" element-loading-text="拼命加载中" style="width: 100%;">

          <el-table-column prop="productName" label="服务名称" width="200" align="center">
          </el-table-column>
          <el-table-column prop="duration" label="剩余时间" width="140" align="center">
            <template slot-scope="scope">
              <span >{{scope.row | rounding}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="开始时间-到期时间" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.startDate+' - '+scope.row.endDate}}</span>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination style="float:right" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

      </div>
      <!-- 产品列表 e -->
    </el-card>

  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import moment from 'moment'

import { OrderProductList } from '../../api/orderMG'

export default {
  data() {
    return {
      expired: 'expired',
      addDetailShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      orderStatus: [
        { key: '全部', value: 1 },
        { key: '已到期', value: 2 },
        { key: '7天内', value: 3 },
        { key: '15天内', value: 4 },
        { key: '30天内', value: 5 },
        { key: '30天以上', value: 6 }
      ],

      props: { multiple: true },
      formInline: {
        page: 1,
        pageSize: 10,
        dateCount: null,
        productName: '',
      },
      daterange:['',  ''],
      listData:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline, this.$route.query.flag)
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter,flag) {
      this.loading = true 
      var params = {
        page: parameter.page,
        pageSize: parameter.pageSize,
        dateCount: parameter.dateCount,
        productName: parameter.productName,
      }
      if(flag==1){
          //未到期产品
          const end = moment().format('yyyy-MM-DD 23:59:59')
          params['endTime'] = end
      }else if(flag==2){
          //即将到期产品
          const start = moment().format('yyyy-MM-DD 00:00:00')
          params['startTime'] = start
          const end = moment().add(1,'M').format('yyyy-MM-DD 23:59:59')
          params['endTime'] = end
      }else{
        if(this.daterange[0]){
          const start = moment(this.daterange[0]).format('yyyy-MM-DD 00:00:00')
          params['startTime'] = start
        }
        if(this.daterange[1]){
          const end = moment(this.daterange[1]).format('yyyy-MM-DD 23:59:59')
          params['endTime'] = end
        }
      }
      OrderProductList(params)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.pageSize
            this.pageparm.total = res.maxPage
          }
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline, null)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline, null)
    },
  },
  filters: {
    rounding(row) {
      var a = moment();
      var b = moment(row.endDate);
      const duration = b.diff(a, 'days') 
      if (duration > 0) {
        return duration + '天'
      }
      return '已过期'
    }
  }
}
</script>

<style scoped>
.product-table{
  height: 500px
}
.box-card {
  margin-top: 20px;
}
.expired {
  color: brown;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/goods/Product.vue